import React from 'react';
import css from './index.module.scss';
import { Iphone } from '../Iphone';
import { MacBook } from '../MacBook';
import { Image } from '../Image';
import csx from 'classnames';
import { BackgroundText } from '../BackgroundText';

interface PostHeaderProps {
  subtitle: string;
  title: string;
  description?: string;
  themeColor?: string;
  imgSrc?: string;
  device?: 'phone' | 'desktop';
}

export const PostHeader = (props: PostHeaderProps) => {
  const style = props.themeColor
    ? { backgroundColor: props.themeColor }
    : undefined;

  const isDevice = props.device?.length > 0;
  const absolutePath = `${__PATH_PREFIX__}${props.imgSrc}`;
  const isSvg = props.imgSrc?.includes?.('.svg');
  const imgStyle = {
    objectFit: isSvg ? 'contain' : 'cover',
  } as const;

  return (
    <div className={css.container}>
      <div
        className={csx(css.scene, { [css.scene_fading]: isDevice })}
        style={style}
      >
        {props.device === 'phone' ? (
          <Iphone className={css.device} imgUrl={absolutePath} />
        ) : props.device === 'desktop' ? (
          <MacBook className={css.device} imgUrl={absolutePath} />
        ) : props.imgSrc?.length ? (
          <Image
            src={absolutePath}
            className={css.img}
            style={imgStyle}
          />
        ) : (
          <BackgroundText>{props.title}</BackgroundText>
        )}
      </div>
      <div className={css.info}>
        <p className={css.subtitle}>{props.subtitle}</p>
        <h1 className={css.title}>{props.title}</h1>
        <p className={css.description}>{props.description}</p>
      </div>
    </div>
  );
};
